import { Component, OnDestroy, OnInit, NgZone } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { I18n, Amplify, Hub, Auth } from "aws-amplify";
import { AuthenticatorService, translations } from "@aws-amplify/ui-angular";
import {
    BaseUserService,
    SpaceService,
    ViewerService,
    SupportModalComponent,
    SupportService,
} from "@smarterplan/ngx-smarterplan-core";
import { translate } from "@aws-amplify/ui";
import awsExports from "../../aws-exports";

I18n.putVocabularies(translations);
I18n.putVocabularies({
    fr: {
        "Your email address": "Votre adresse e-mail",
        "Your password": "Votre mot de passe",
        "Send Code": "Confirmer",
        Code: "Votre code de validation",
        Password: "Votre nouveau mot de passe",
        "Confirm Password": "Confirmez votre nouveau mot de passe",
        "User does not exist.": "Ce compte utilisateur n'existe pas.",
        "Incorrect username or password.":
            "Identifiant ou mot de passe incorrect.",
        "The user does not exist":
            "Cette adresse mail n'est affilié à aucun compte utilisateur",
        "Attempt limit exceeded, please try after some time.":
            "Limite de tentatives dépassée, veuillez réessayer après un certain temps.",
        "Your passwords must match": "Vos mots de passe doivent correspondre",
        "Invalid verification code provided, please try again.":
            "Code de vérification fourni non valide, veuillez réessayer.",
    },
    en: {
        "Your email address": "Your email address",
        "Your password": "Your password",
        "Send Code": "Confirm",
        Code: "Your validation code",
        Password: "Your new password",
        "Confirm Password": "Confirm your new password",
        "User does not exist.": "This user account does not exist.",
        "Incorrect username or password.": "Incorrect username or password.",
        "The user does not exist":
            "This email address is not affiliated with any user account",
        "Attempt limit exceeded, please try after some time.":
            "Attempt limit exceeded, please try after some time.",
        "Your passwords must match": "Your passwords must match",
        "Invalid verification code provided, please try again.":
            "Invalid verification code provided, please try again.",
    },
});
@Component({
    selector: "app-auth",
    templateUrl: "./auth.component.html",
    styleUrls: ["./auth.component.scss"],
})
export class AuthComponent implements OnInit, OnDestroy {
    user: any;

    loading = false;

    formFields = {
        signIn: {
            username: {
                labelHidden: false,
                isRequired: true,
                label: translate("Your email address"),
                placeholder: translate("Enter your email"),
            },
            password: {
                labelHidden: false,
                isRequired: true,
                label: translate("Your password"),
                placeholder: translate("Enter your password"),
            },
        },
    };

    userSub: Subscription;

    hubListener = (data) => {
        switch (data.payload.event) {
            case "signIn":
                this.loading = true;
                this.user = data.payload.data;
                this.handleRedirection();
                break;
            case "signUp":
                // console.log("user signed up");
                break;
            case "signOut":
                // console.log("user signed out");
                break;
            case "signIn_failure":
                // console.log("user sign in failed");
                break;
            case "configured":
                // console.log("the Auth module is configured");
                break;
            case "tokenRefresh":
                // console.log("tokenRefresh", data);
                //  console.log(this.authenticator.user);
                this.loading = true;
                this.onTokenRefresh();
                break;
            default:
                console.log(data.payload.event);
        }
    };

    constructor(
        public authenticator: AuthenticatorService,
        private router: Router,
        private ngZone: NgZone,
        private userService: BaseUserService,
        private activatedRoute: ActivatedRoute,
        private supportService: SupportService,
    ) {
        Amplify.configure(awsExports);
    }

    async ngOnInit() {
        Hub.listen("auth", this.hubListener);
        try {
            const cognitoUser = await Auth.currentAuthenticatedUser();
            this.loading = true;
            this.user = cognitoUser;
            this.handleRedirection();
        } catch (error) {
            if (this.authenticator.user) {
                this.authenticator.signOut();
            }
        }
    }

    ngOnDestroy() {
        Hub.remove("auth", this.hubListener);
    }

    async handleRedirection() {
        if (!this.user) {
            return;
        }
        if (!this.userService.cu || !this.userService.currentMissions) {
            await this.userService.current(this.user);
        }
        if (this.userService.cu) {
            const missions = this.userService.currentMissions;
            if (missions) {
                // any other user goes to dashboard
                this.ngZone.run(() => {
                    this.router.navigate(["dashboard"]);
                });
            }
        }
    }

    async onTokenRefresh() {
        try {
            const cognitoUser = await Auth.currentAuthenticatedUser();
            this.user = cognitoUser;
            this.handleRedirection();
        } catch (error) {
            this.loading = false;
        }
    }

    openSupportForm() {
        this.supportService.openSupportForm(SupportModalComponent);
    }
}
